import { FormControl, FormHelperText, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import {
  getContextualProductTypeOptions,
  getProductTypeOptionLabel,
  isArchivedProductType,
  retainSelectableProductTypes,
} from "producttypes/archivedProductTypes";
import { Controller, UseFormMethods } from "react-hook-form";
import useProductTypes from "../teams/useProductTypes";

export function ProductTypeChips({
  name,
  defaultValue,
  form,
  onChange,
  allowArchived = false,
  options,
}: {
  name: string;
  defaultValue?: string[];
  form: UseFormMethods<Record<string, any>>;
  onChange?: (value: string[]) => void;
  allowArchived?: boolean;
  options?: string[];
}) {
  const discoveredProductTypes = useProductTypes();
  const all = getContextualProductTypeOptions(
    options || discoveredProductTypes,
    defaultValue || [],
    allowArchived
  );

  return (
    <Controller
      name={name}
      control={form.control}
      defaultValue={defaultValue || []}
      render={(field) => (
        <FormControl fullWidth>
          <Autocomplete
            multiple
            options={all}
            freeSolo
            getOptionDisabled={(option) =>
              !allowArchived && isArchivedProductType(option)
            }
            renderOption={(option) => getProductTypeOptionLabel(option)}
            value={field.value || ""}
            onChange={(_, value: string[]) => {
              const current = Array.isArray(field.value) ? field.value : [];
              const next = allowArchived
                ? value
                : retainSelectableProductTypes(value, current);
              form.setValue(name, next);
              if (onChange) {
                onChange(next);
              }
            }}
            renderInput={(params) => (
              <TextField {...params} variant="standard" label="Product types" />
            )}
          />
          <FormHelperText>{form.errors[name]?.message}</FormHelperText>
        </FormControl>
      )}
    />
  );
}
